export default __webpack_public_path__ + "static/media/newLogo.67586107.png";